import { useEffect, useState } from 'react';
import { BaseUserInfo } from '../interface/BaseUserInfo';
import { Container, Col, Row } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../api/CallUserApi';
import InputBigMediaCategory from '../components/InputBigMediaCategory';
import { useParams } from 'react-router-dom';
import { DANCE_TITLE, THEATER_TITLE, getMediaUrl } from '../utils';
import HelpArea from '../components/HelpComponent';
import { getBigMediaCategoryTmpById, getSubBigMediaCategoryTmpById } from '../localStorageUtils';

const RegisterBigMediaCategory: React.FunctionComponent = () => {
  const [userInfo, setUserInfo] = useState<BaseUserInfo>({} as BaseUserInfo);
  const [bigMediaCategory, setBigMediaCategory] = useState('');
  const navigate = useNavigate();
  const params = useParams();
  const [reportId, setReportId] = useState<string>('');
  const [subBigMediaCategory, setSubBigMediaCategory] = useState('');
  const [helps, setHelps] = useState<any[]>([]);
  const [helpPaddingTop, setHelpPaddingTop] = useState<any>({});

  const location = useLocation();

  const nextPage = (): void => {
    navigate('/users/report/edit/' + reportId + '/smallMediaCategory');
  };

  const moveMediaPage = () => {
    const nextPage = getMediaUrl(location.pathname);
    navigate(nextPage);
  };

  useEffect(() => {
    const getData = async () => {
      const profile: BaseUserInfo = await api.getProfile();
      setUserInfo(profile);
      const id = params ? params.reportId : '';
      if (!id) throw Error('report id パラメータが存在しません');
      setReportId(id);
      const prevSub = getSubBigMediaCategoryTmpById(profile._id);
      if (prevSub) {
        setSubBigMediaCategory(prevSub);
      }
      const prevBigMediaCategory = getBigMediaCategoryTmpById(profile._id);
      if (prevBigMediaCategory) {
        setBigMediaCategory(prevBigMediaCategory);
        return;
      }
      const report = await api.getReport(id);
      const categories = report.media.categories;
      if (categories[0] === DANCE_TITLE || categories[0] === THEATER_TITLE) {
        setSubBigMediaCategory(categories[0]);
        setBigMediaCategory(categories[1]);
      } else {
        setBigMediaCategory(categories[0]);
      }
    };
    getData();
  }, []);

  return (
    <>
      <Container>
        <Row>
          <Col md={9} lg={9}>
            <InputBigMediaCategory
              bigMediaCategory={bigMediaCategory}
              movePage={nextPage}
              setBigMediaCategory={setBigMediaCategory}
              userInfo={userInfo}
              subBigMediaCategory={subBigMediaCategory}
              setSubBigMediaCategory={setSubBigMediaCategory}
              moveMediaPage={moveMediaPage}
              setDisplayHelpData={setHelps}
              setHelpPaddingTop={setHelpPaddingTop}
            />
          </Col>
          <HelpArea helps={helps} helpPaddingTop={helpPaddingTop} />
        </Row>
      </Container>
    </>
  );
};
export default RegisterBigMediaCategory;
